module.exports = __webpack_public_path__ + "static/alfanova-ef9813946e1dddbb1b875600e3713ca3.jpg";